module.exports = __webpack_public_path__ + "img/doc.474743f4.svg";